import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    font: fontText('normal', theme.fontSize.s, 20),
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    '&.Mui-error': {
      color: theme.color.greys[80],
    }
  },
  icon: {
    position: 'relative',
    flexShrink: 0,
    color: theme.color.reds[100],
  },
  errorMessage: {}
}), { name: 'FieldErrorMessage', index: StylesIndexInjections.UI_MOLECULES });
